export function StarIcon() {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="size-full"
    >
      <path
        d="M6 1.25 7.41 4.1l3.14.46-2.27 2.21.54 3.13L6 8.43 3.18 9.9l.54-3.13L1.45 4.56 4.59 4.1 6 1.25Z"
        stroke="currentColor"
        strokeWidth="1"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function SignalIcon({ clipId = 'clip0_451_1201' }) {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="size-full"
    >
      <g clipPath={`url(#${clipId})`}>
        <path
          d="M3.0625 7.4375C3.99076 7.4375 4.881 7.80625 5.53737 8.46263C6.19375 9.119 6.5625 10.0092 6.5625 10.9375"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.0625 4.8125C4.68695 4.8125 6.24487 5.45781 7.39353 6.60647C8.54219 7.75513 9.1875 9.31305 9.1875 10.9375"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.0625 2.1875C4.21157 2.1875 5.34938 2.41383 6.41098 2.85355C7.47258 3.29328 8.43717 3.9378 9.24968 4.75032C10.0622 5.56283 10.7067 6.52742 11.1464 7.58902C11.5862 8.65062 11.8125 9.78843 11.8125 10.9375"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.28125 11.375C3.64369 11.375 3.9375 11.0812 3.9375 10.7188C3.9375 10.3563 3.64369 10.0625 3.28125 10.0625C2.91881 10.0625 2.625 10.3563 2.625 10.7188C2.625 11.0812 2.91881 11.375 3.28125 11.375Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id={clipId}>
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export function ChevronIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 256 256"
      fill="currentColor"
      className="size-full"
    >
      <path d="M213.66,101.66l-80,80a8,8,0,0,1-11.32,0l-80-80A8,8,0,0,1,53.66,90.34L128,164.69l74.34-74.35a8,8,0,0,1,11.32,11.32Z" />
    </svg>
  )
}

export function SortChevron() {
  return (
    <svg
      viewBox="0 0 8 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="size-full"
    >
      <path
        d="M1.5 3 4 5.5 6.5 3"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
